import * as imageConversion from 'image-conversion'

export async function compressAccurately(inputFile, toSize) {
    const resAvatarBlob = await imageConversion.compressAccurately(inputFile, toSize);
    const resAvatarFile = new window.File(
      [resAvatarBlob],
      inputFile.name,
      { type: inputFile.type },
    );
    resAvatarFile.uid = inputFile.uid
    return resAvatarFile;
  }